import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ac5d1c42")

_pushScopeId("data-v-ac5d1c42")
const _hoisted_1 = { class: "pt-16 fixed inset-0 overflow-y-auto z-10 overflow-scroll" }
const _hoisted_2 = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "absolute z-0 inset-0  backdrop-filter backdrop-blur-xl" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", {
  "aria-hidden": "true",
  class: "hidden sm:inline-block sm:align-middle sm:h-screen"
}, "​", -1)
const _hoisted_5 = {
  class: "z-0 inline-block align-bottom text-left transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full",
  style: {"width":"-moz-available"}
}
const _hoisted_6 = { class: "float-right  -mr-7 mt-5" }
const _hoisted_7 = { class: "text-3xl bold text-bp-dark bg-gray-70 text-center\n      p-5 pt-2 pb-0" }
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "m-0 sm:mx-16 space-y-4" }
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = { class: "w-1/2 mr-4" }
const _hoisted_12 = { class: "text-gray-900 text-md" }
const _hoisted_13 = { class: "text-gray-300 text-sm" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "w-1/2 mr-4" }
const _hoisted_16 = { class: "text-gray-900 text-md" }
const _hoisted_17 = { class: "text-gray-300 text-sm" }
const _hoisted_18 = { class: "flex" }
const _hoisted_19 = { class: "w-1/2 mr-4" }
const _hoisted_20 = { class: "text-gray-900 text-md" }
const _hoisted_21 = { class: "text-gray-300 text-sm" }
const _hoisted_22 = { class: "text-md bold text-bp-dark" }
const _hoisted_23 = { class: "grid sm:grid-cols-2 gap-4 sm:gap-0 sm:mx-7" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_btn_edit = _resolveComponent("btn-edit")
  const _component_btn_close = _resolveComponent("btn-close")
  const _component_input_field = _resolveComponent("input-field")
  const _component_cancel_subscription_dialog = _resolveComponent("cancel-subscription-dialog")
  const _component_default_button = _resolveComponent("default-button")
  const _component_DefaultCardLayout = _resolveComponent("DefaultCardLayout")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.showButton === true)
      ? (_openBlock(), _createBlock(_component_btn_edit, {
          key: 0,
          "btn-position": "mr-6 -mt-1",
          "button-text": "Search free Images",
          "button-x-padding": "px-1",
          "button-y-padding": "py-2",
          class: "text-xs mb-1",
          onCickButton: _ctx.uploadImage,
          onClick: _ctx.toggleDialog
        }, null, 8, ["onCickButton", "onClick"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", {
          "aria-hidden": "true",
          class: "fixed inset-0 transition-opacity",
          title: "overlay_for_confirm",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelDialog && _ctx.cancelDialog(...args)))
        }, [
          _hoisted_3
        ]),
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_btn_close, {
              "css-class": "absolute z-20",
              onClick: _ctx.cancelDialog
            }, null, 8, ["onClick"])
          ]),
          _createVNode(_component_DefaultCardLayout, { "card-padding": "px-6 md:px-1 mb-6" }, {
            default: _withId(() => [
              _createVNode("h1", _hoisted_7, _toDisplayString(_ctx.$t("profile.subscribed.changeTitle")), 1),
              _createVNode("form", {
                class: "space-y-5 mt-5",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
              }, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, [
                        _createVNode("p", _hoisted_12, _toDisplayString(_ctx.$t("profile.subscribed.startdayTitle")), 1),
                        _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("profile.subscribed.optionalTitle")), 1)
                      ]),
                      _createVNode(_component_input_field, {
                        "input-id": "Date",
                        "input-placeholder": "DATE"
                      })
                    ]),
                    _createVNode("div", _hoisted_14, [
                      _createVNode("div", _hoisted_15, [
                        _createVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("profile.subscribed.timeTitle")), 1),
                        _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("profile.subscribed.optionalTitle")), 1)
                      ]),
                      _createVNode(_component_input_field, {
                        "input-id": "Time",
                        "input-placeholder": "TIME"
                      })
                    ]),
                    _createVNode("div", _hoisted_18, [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("p", _hoisted_20, _toDisplayString(_ctx.$t("profile.subscribed.durationTitle")), 1),
                        _createVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("profile.subscribed.optionalTitle")), 1)
                      ]),
                      _createVNode(_component_input_field, {
                        "input-placeholder": _ctx.$t('profile.subscribed.weekTitle'),
                        "input-id": "Week"
                      }, null, 8, ["input-placeholder"])
                    ]),
                    _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("profile.subscribed.cancelSubscriptionDetail")), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_23, [
                  _renderSlot(_ctx.$slots, "EditSubscribtionButton", {}, () => [
                    _createVNode(_component_cancel_subscription_dialog, { class: "mr-1 absolute" })
                  ]),
                  _createVNode(_component_default_button, {
                    "button-text": _ctx.$t('profile.subscribed.btnSaveChanges'),
                    "button-width": "w-auto",
                    "button-x-padding": "px-7"
                  }, null, 8, ["button-text"])
                ])
              ], 32)
            ]),
            _: 3
          })
        ])
      ])
    ], 512), [
      [_vShow, _ctx.dialogVisible]
    ])
  ], 64))
})